import * as i0 from '@angular/core';
import { Directive, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';

/** @deprecated The directive should not be used */
class XpoChipColor {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    get xpoChipColor() {
        return this.xpoChipColorValue;
    }
    set xpoChipColor(value) {
        this.xpoChipColorValue = value;
        if (this.isHexColor(this.xpoChipColor)) {
            this.elementRef.nativeElement.style.backgroundColor = this.xpoChipColor;
            this.elementRef.nativeElement.style.color = this.isColorDark(this.xpoChipColor) ? '#FFFFFF' : '#171717';
        }
    }
    isHexColor(hexColor) {
        const regexp = /^[0-9a-fA-F]+$/;
        return hexColor.startsWith('#') && regexp.test(hexColor.substring(1));
    }
    isColorDark(hexColor) {
        const colorVal = hexColor.substring(1); // strip #
        const rgb = parseInt(colorVal, 16); // convert rrggbb to decimal
        /* eslint-disable */
        const r = (rgb >> 16) & 0xff; // extract red
        const g = (rgb >> 8) & 0xff; // extract green
        const b = (rgb >> 0) & 0xff; // extract blue
        /* eslint-enable */
        const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
        return luma < 160; // this value should be verified with UX
    }
}
XpoChipColor.ɵfac = function XpoChipColor_Factory(t) { return new (t || XpoChipColor)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
XpoChipColor.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoChipColor, selectors: [["", "xpoChipColor", ""]], inputs: { xpoChipColor: "xpoChipColor" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoChipColor, [{
        type: Directive,
        args: [{
                selector: '[xpoChipColor]',
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, { xpoChipColor: [{
            type: Input,
            args: ['xpoChipColor']
        }] }); })();

/** @deprecated The directive should not be used */
class XpoChipSmall {
}
XpoChipSmall.ɵfac = function XpoChipSmall_Factory(t) { return new (t || XpoChipSmall)(); };
XpoChipSmall.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoChipSmall, selectors: [["", "xpoChipSmall", ""]], hostAttrs: [1, "xpo-Chip--small"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoChipSmall, [{
        type: Directive,
        args: [{
                selector: '[xpoChipSmall]',
                host: { class: 'xpo-Chip--small' },
            }]
    }], null, null); })();

/** @deprecated The directive should not be used */
class XpoBadgeChip {
}
XpoBadgeChip.ɵfac = function XpoBadgeChip_Factory(t) { return new (t || XpoBadgeChip)(); };
XpoBadgeChip.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoBadgeChip, selectors: [["", "xpo-badge-chip", ""], ["", "xpoBadgeChip", ""]], hostAttrs: [1, "xpo-BadgeChip"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBadgeChip, [{
        type: Directive,
        args: [{
                selector: '[xpo-badge-chip], [xpoBadgeChip] ',
                host: {
                    class: 'xpo-BadgeChip',
                },
            }]
    }], null, null); })();
/** @deprecated The directive should not be used */
class XpoBadgeChipNegative {
}
XpoBadgeChipNegative.ɵfac = function XpoBadgeChipNegative_Factory(t) { return new (t || XpoBadgeChipNegative)(); };
XpoBadgeChipNegative.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoBadgeChipNegative, selectors: [["", "xpo-badge-chip-negative", ""], ["", "xpoBadgeChipNegative", ""]], hostAttrs: [1, "xpo-BadgeChip", "xpo-BadgeChip--negative"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBadgeChipNegative, [{
        type: Directive,
        args: [{
                selector: '[xpo-badge-chip-negative], [xpoBadgeChipNegative] ',
                host: {
                    class: 'xpo-BadgeChip xpo-BadgeChip--negative',
                },
            }]
    }], null, null); })();
/** @deprecated The directive should not be used */
class XpoBadgeChipPositive {
}
XpoBadgeChipPositive.ɵfac = function XpoBadgeChipPositive_Factory(t) { return new (t || XpoBadgeChipPositive)(); };
XpoBadgeChipPositive.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoBadgeChipPositive, selectors: [["", "xpo-badge-chip-positive", ""], ["", "xpoBadgeChipPositive", ""]], hostAttrs: [1, "xpo-BadgeChip", "xpo-BadgeChip--positive"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoBadgeChipPositive, [{
        type: Directive,
        args: [{
                selector: '[xpo-badge-chip-positive], [xpoBadgeChipPositive] ',
                host: {
                    class: 'xpo-BadgeChip xpo-BadgeChip--positive',
                },
            }]
    }], null, null); })();

class XpoTag {
}
XpoTag.ɵfac = function XpoTag_Factory(t) { return new (t || XpoTag)(); };
XpoTag.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoTag, selectors: [["", "xpoTag", ""]], hostAttrs: [1, "xpo-Tag"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoTag, [{
        type: Directive,
        args: [{
                selector: '[xpoTag]',
                host: { class: 'xpo-Tag' },
            }]
    }], null, null); })();

/** @deprecated The directive should not be used */
class XpoLargeTag {
}
XpoLargeTag.ɵfac = function XpoLargeTag_Factory(t) { return new (t || XpoLargeTag)(); };
XpoLargeTag.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoLargeTag, selectors: [["", "xpoTagLarge", ""]], hostAttrs: [1, "xpo-Tag", "xpo-tag--large"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoLargeTag, [{
        type: Directive,
        args: [{
                selector: '[xpoTagLarge]',
                host: { class: 'xpo-Tag xpo-tag--large' },
            }]
    }], null, null); })();

class XpoChipsModule {
}
XpoChipsModule.ɵfac = function XpoChipsModule_Factory(t) { return new (t || XpoChipsModule)(); };
XpoChipsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoChipsModule });
XpoChipsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule], MatChipsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoChipsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [
                    XpoChipColor,
                    XpoChipSmall,
                    XpoTag,
                    XpoLargeTag,
                    XpoBadgeChip,
                    XpoBadgeChipNegative,
                    XpoBadgeChipPositive,
                ],
                exports: [
                    XpoChipColor,
                    XpoChipSmall,
                    XpoTag,
                    XpoBadgeChip,
                    XpoBadgeChipNegative,
                    XpoBadgeChipPositive,
                    XpoLargeTag,
                    MatChipsModule,
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoChipsModule, { declarations: [XpoChipColor,
        XpoChipSmall,
        XpoTag,
        XpoLargeTag,
        XpoBadgeChip,
        XpoBadgeChipNegative,
        XpoBadgeChipPositive], imports: [CommonModule], exports: [XpoChipColor,
        XpoChipSmall,
        XpoTag,
        XpoBadgeChip,
        XpoBadgeChipNegative,
        XpoBadgeChipPositive,
        XpoLargeTag,
        MatChipsModule] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoBadgeChip, XpoBadgeChipNegative, XpoBadgeChipPositive, XpoChipColor, XpoChipSmall, XpoChipsModule, XpoLargeTag, XpoTag };
